<template>
	<div>
		<div class="container-fluid">
			<form class="form-horizontal" action="." method="post">
				<div class="row">
					<div class="tab-content col-lg-6 col-md-8 mr-auto ml-auto col-sm-12">
						<div class="form-group">
							<label>{{ 'Group name' | translate }}</label>
							<input type="text" :class="nameError ? 'error' : ''" v-model="name" class="form-control" />
							<div class="text-right text-danger" v-if="nameError">
								{{ nameError }}
							</div>
						</div>
						<div class="form-group">
							<label>{{ 'Group address' | translate }}</label>
							<input :class="addressError ? 'error' : ''" type="text" v-model="address" class="form-control" />
							<div class="text-right text-danger" v-if="addressError">
								{{ addressError }}
							</div>
						</div>
						<!-- <div class="form-group">
							<label>{{ 'Street' | translate }}</label>
							<input type="text" :class="streetError ? 'error' : ''" v-model="street" class="form-control" />
							<div class="text-right text-danger" v-if="streetError">
								{{ streetError }}
							</div>
						</div>
						<div class="form-group">
							<label>{{ 'District' | translate }}</label>
							<input type="text" v-model="district" :class="districtError ? 'error' : ''" class="form-control" />
							<div class="text-right text-danger" v-if="districtError">
								{{ districtError }}
							</div>
						</div>
						<div class="form-group">
							<label>{{ 'Location name' | translate }}</label>
							<input :class="locationNameError ? 'error' : ''" type="text" v-model="locationName" class="form-control" />
							<div class="text-right text-danger" v-if="locationNameError">
								{{ locationNameError }}
							</div>
						</div> -->
						<div class="form-group">
							<label>{{ 'Start of study' | translate }}</label>
							<datepicker v-model="lessonsStarts" :format="format" class="-control"></datepicker>
						</div>
						<div class="form-group">
							<label>{{ 'Start time' | translate }}</label>
							<vue-timepicker v-model="lessonTime" :minute-interval="5" hide-clear-button></vue-timepicker>
						</div>
						<div v-if="myRole !== 'teacher'" class="form-group">
							<label>{{ 'Group teacher' | translate }}</label>
							<v-select :class="teacherError ? 'error' : ''" :on-change="changeTeacher" :value.sync="teacherName"
								:options="teacherList" @search="onSearch"></v-select>
							<div class="text-right text-danger" v-if="teacherError">
								{{ teacherError }}
							</div>
						</div>
						<div class="form-group">
							<label>{{ 'Working days' | translate }}: </label>
							<input type="checkbox" v-model="days" value="Mo" />
							{{ 'Mo' | translate }}
							<input type="checkbox" v-model="days" value="Tu" />
							{{ 'Tu' | translate }}
							<input type="checkbox" v-model="days" value="We" />
							{{ 'We' | translate }}
							<input type="checkbox" v-model="days" value="Th" />
							{{ 'Th' | translate }}
							<input type="checkbox" v-model="days" value="Fr" />
							{{ 'Fr' | translate }}
							<input type="checkbox" v-model="days" value="Sa" />
							{{ 'Sa' | translate }}
							<input type="checkbox" v-model="days" value="Su" />
							{{ 'Su' | translate }}
							<div class="text-right text-danger" v-if="daysError">
								{{ daysError }}
							</div>
						</div>
						<div v-if="age === 'Junior' ||
								age === 'Older' ||
								age === 'Average' ||
								age === 'class'
								" class="form-group">
							<label>{{ 'Group age' | translate }}</label>
							<select name="" id="" @change="ageName = ''" v-model="age" class="form-control">
								<option value="Junior">{{ 'Junior' | translate }}</option>
								<option value="Average">{{ 'Average' | translate }}</option>
								<option value="Older">{{ 'Older' | translate }}</option>
								<option value="class">{{ 'Class' | translate }}</option>
							</select>
						</div>
						<div class="form-group" v-if="age !== 'Junior' && age !== 'Older' && age !== 'Average'">
							<label>{{ 'Group age name' | translate }}</label>
							<input type="text" v-model="ageName" class="form-control" />
						</div>
					</div>
				</div>
				<div class="col-12 text-center">
					<input type="submit" :value="'Save' | translate" @click.prevent="changeProfile"
						class="btn btn-primary submit" />
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
	name: 'group-profile',
	data() {
		return {
			address: '',

			street: '-',
			district: '-',

			days: [],
			age: '',
			myRole: this.$store.state.myProfile.role,
			format: 'dd/MM/yyyy',
			ageName: '',
			teacherList: [],
			lessonsStarts: '',
			locationName: '',
			name: '',
			lessonTime: {
				HH: '07',
				mm: '00',
			},
			teacherName: '',
			teacher: '',
			addressError: '',
			streetError: '',
			districtError: '',
			daysError: '',
			lessonsStartsError: '',
			teacherError: '',
			locationNameError: '',
			nameError: '',

			searchTeacherQuery: null,
			searchTeacherTimer: null,
		}
	},
	components: {
		vSelect,
		Datepicker,
		VueTimepicker,
	},
	methods: {
		changeProfile() {
			this.addressError = ''
			this.streetError = ''
			this.districtError = ''
			this.daysError = ''
			this.locationNameError = ''
			this.nameError = ''
			this.teacherError = ''
			let error = false

			if (this.name === '') {
				this.nameError = this.$t('Field required')
				error = true
			}

			if (this.address === '') {
				this.addressError = this.$t('Field required')
				error = true
			}

			// if (this.street === '') {
			// 	this.streetError = this.$t('Field required')
			// 	error = true
			// }

			// if (this.locationName === '') {
			// 	this.locationNameError = this.$t('Field required')
			// 	error = true
			// }

			// if (this.district === '') {
			// 	this.districtError = this.$t('Field required')
			// 	error = true
			// }

			if (this.days.length === 0) {
				this.daysError = this.$t('Field required')
				error = true
			}

			if (this.teacher === undefined) {
				this.teacherError = this.$t('Field required')
				error = true
			}

			if (error) {
				return false
			}

			let lessonsStarts = null

			if (
				this.lessonsStarts !== null &&
				this.lessonsStarts !== '' &&
				this.lessonsStarts.length !== 10
			) {
				lessonsStarts = this.lessonsStarts.toISOString().slice(0, 10)
			} else {
				lessonsStarts = this.lessonsStarts
			}

			let ageName = this.ageName === '' ? this.age : this.ageName
			let lessonTime = this.lessonTime.HH + ':' + this.lessonTime.mm
			this.axios({
				method: 'patch',
				url: `groups/${this.$route.params.id}`,
				data: {
					address: this.address,
					age: ageName,
					lesson_time: lessonTime,
					lessons_starts: lessonsStarts,
					location_name: this.locationName,
					name: this.name,
					street: this.street,
					district: this.district,
					teacher: this.teacher,
					working_days: this.days,
				},
			}).then(response => {
				this.$toast(this.$t('Changes saved'), {
					className: ['btn-success', 'notif'],
					duration: 3000,
				})
			})
		},
		changeTeacher(val) {
			if (val !== null) {
				this.teacher = val.value
			}
		},
		updateGroupInfo() {
			this.axios({
				method: 'get',
				url: `groups/${this.$route.params.id}`,
			}).then(response => {
				let group = response.data
				this.$store.commit('changeProfile', group)
				this.address = group.address
				this.age = group.age
				this.ageName = group.age
				if (group.lesson_time) {
					this.lessonTime.HH = group.lesson_time.slice(0, 2)
					this.lessonTime.mm = group.lesson_time.slice(3, 5)
				}
				this.lessonsStarts = group.lessons_starts
				this.locationName = group.location_name
				this.street = group.street
				this.district = group.district
				this.name = group.name
				this.days = group.working_days
				this.teacher = group.teacher
				this.teacherName = {
					label:
						group.teacher_last_name +
						' ' +
						group.teacher_first_name,
					// ' ' +
					// group.teacher_middle_name,
					value: group.teacher,
				}
			})

			this.getTeachersList()

			// if (this.myRole !== 'teacher') {
			// 	this.axios({
			// 		method: 'get',
			// 		url: 'users?role=teacher',
			// 	}).then(response => {
			// 		let teacherArray = response.data
			// 		for (var i = 0; i < teacherArray.length; i++) {
			// 			let teacher = {
			// 				value: teacherArray[i].id,
			// 				label:
			// 					teacherArray[i].last_name +
			// 					' ' +
			// 					teacherArray[i].first_name +
			// 					' ' +
			// 					teacherArray[i].middle_name,
			// 			}
			// 			this.teacherList.push(teacher)
			// 		}
			// 	})
			// } else {
			// 	this.teacher = this.$store.state.myProfile.id
			// }
		},
		onSearch(query) {
			console.log("Query", query)

			const timer = 400

			if (this.searchTeacherTimer) {
				clearTimeout(this.searchTeacherTimer)
			}

			this.searchTeacherTimer = setTimeout(() => {
				this.getTeachersList(query)
			}, timer)
		},
		getTeachersList(query) {
			if (this.$store.state.myProfile.role !== 'teacher') {
				this.axios({
					method: 'get',
					url: `users/users-dropdown?role=teacher&page=1&step=12&q=${query ? query : ''}`,
				}).then(response => {
					let teacherArray = response.data

					let newTeacherList = []

					for (var i = 0; i < teacherArray.length; i++) {
						let teacher = {
							value: teacherArray[i].id,
							label:
								teacherArray[i].last_name +
								' ' +
								teacherArray[i].first_name
							// +
							// ' ' +
							// teacherArray[i].middle_name,
						}

						newTeacherList.push(teacher)
					}

					this.teacherList = newTeacherList
				})
			} else {
				this.teacher = this.$store.state.myProfile.id
			}
		},
	},

	beforeMount() {
		this.updateGroupInfo()
	},

	// created() {
	// 	this.getTeachersList()
	// },

	watch: {
		$route(from, to) {
			this.updateGroupInfo()
		},
	},
}
</script>

<style scoped>
.submit {
	margin-top: 20px;
	margin-bottom: 20px;
}

.tab-content {
	border: 1px solid buttonface;
	border-radius: 10px;
	background: #fff;
	padding-top: 30px;
	padding-bottom: 30px;
}
</style>
